export const langHandler = () => {
  // const langBlock = document.querySelector(".header-lang");
  // const item = langBlock.querySelector(".header-lang__item");
  // const list = langBlock.querySelector(".header-lang__list");
  // // Функция открытия/закрытия
  // function toggleLangList() {
  //   const isActive = langBlock.classList.toggle("header-lang--active");
  //   if (isActive) {
  //     list.style.maxHeight = list.scrollHeight + "px";
  //   } else {
  //     list.style.maxHeight = "0";
  //   }
  // }
  // // Обработчик клика по кнопке
  // item.addEventListener("click", (e) => {
  //   e.stopPropagation(); // не дадим всплыть до document
  //   toggleLangList();
  // });
  // // Обработчик клика вне .header-lang
  // document.addEventListener("click", (e) => {
  //   if (
  //     langBlock.classList.contains("header-lang--active") &&
  //     !langBlock.contains(e.target)
  //   ) {
  //     // Если открыт и клик не внутри – закрываем
  //     langBlock.classList.remove("header-lang--active");
  //     list.style.maxHeight = "0";
  //   }
  // });
};
